// extracted by mini-css-extract-plugin
module.exports = {"commentsection":"Commentsection_commentsection__3vt8H","btns":"Commentsection_btns__1OOib","submit":"Commentsection_submit__2HPgp","cancel":"Commentsection_cancel__2RVG3"};